import BEM from 'bem.js';
import numeral from 'numeral';
import Prices from '../../data/expositions/prices';
import toArray from 'arrayify';


const BLOCK_CHECKUP = 'checkup';
const BLOCK_INSPECTION = 'inspection';
const BLOCK_PRODUCT = 'exposition-prices';

const ELEMENT_INPUT = 'input';
const ELEMENT_PRICE = 'price';
const ELEMENT_SINGLEINPUT = 'ticket-single';
const ELEMENT_TICKETS = 'tickets';
const ELEMENT_TOTAL = 'ticket-total';


export default class CalculatePrices {
    constructor() {
        this.prices = new Prices();
        this.priceContainer = BEM.getBEMNode(BLOCK_PRODUCT);

        this.prices.resetDiscount();
        this.footer = BEM.getBEMNode("inspection", "foot");
        try {
            let discounts = JSON.parse(this.footer.dataset.discounts);
            discounts.forEach(discount => {
                this.prices.setDiscount(discount.name, discount.discount)
            });
        } catch (error) {

        }

        numeral.register('locale', 'nl', {
            delimiters: {
                thousands: '',
                decimal: ','
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            currency: {
                symbol: '€'
            }
        });

        if(this.priceContainer && this.priceContainer.dataset.lang === 'nl'){
            numeral.locale('nl');
        }

        this.inputs = BEM.getBEMNodes(BLOCK_PRODUCT, ELEMENT_INPUT);
        for(let input of toArray(this.inputs)){
            input.onchange = () => this.ticketsChange(input, false); // jshint ignore:line
            this.ticketsChange(input, true);
        }
    }

    ticketsChange(input, initial) {
        if (!initial) {
            this.prices.resetDiscount();
        }

        let parent = input.parentNode.parentNode.parentNode;
        let id = parent.dataset.id;
        let name = parent.dataset.name;
        let amount = 0;
        if(!isNaN(input.value)) {
            amount = Number(input.value);
        }
        let singleValueElement = BEM.getChildBEMNode(parent, BLOCK_PRODUCT, ELEMENT_SINGLEINPUT);
        let totalValueElement = BEM.getChildBEMNode(parent, BLOCK_PRODUCT, ELEMENT_TOTAL);

        let singleValue = numeral(singleValueElement.innerText);
        let totalValue = numeral(singleValue.value() * amount);

        totalValueElement.innerText = totalValue.format('0.00');

        this.updatePrices(id, name, amount, singleValue);
    }

    updatePrices(id, name, amount, singleValue) {
        if(!id){
            console.error('please provide an id'); // jshint ignore:line
            return;
        }
        id = id.trim();

        if (amount > 0 && singleValue.value() > 0){
            this.prices.updateOrCreateRow(id, name, singleValue.value(), amount);
        } else if (amount <= 0) {
            this.prices.deleteRow(id);
        } else if (singleValue <= 0) {
            this.prices.deleteRow(id);
        }

        this.updateInspection();
    }

    removeInspectionRows() {
        let inspectionTickets = BEM.getBEMNode(BLOCK_INSPECTION, ELEMENT_TICKETS);
        while (inspectionTickets.firstChild) {
            inspectionTickets.removeChild(inspectionTickets.firstChild);
        }
    }

    createDeleteButton(id) {
        let delButton = document.createElement('button');
        delButton.innerText = 'X';
        delButton.classList.add('delete__button');
        delButton.classList.add('button');
        delButton.classList.add('button--delete');
        delButton.dataset.id = id;
        delButton.onclick = (event) => {
            event.preventDefault();
            let input = document.querySelector(`[data-id="${delButton.dataset.id}"] .exposition-prices__input`);
            input.value = 0;
            input.onchange();
        };
        return delButton;
    }

    createRow(price) {
        let row = document.createElement('tr');
        row.classList.add(price.id);

        let nameTd = document.createElement('td');
        nameTd.innerText = `${price.amount} x ${price.name}`;
        row.appendChild(nameTd);

        let priceTd = document.createElement('td');
        priceTd.className = BEM.getBEMClassName(BLOCK_INSPECTION, ELEMENT_PRICE);
        priceTd.innerText = `€${numeral(price.getTotal()).format('0.00')}`;
        row.appendChild(priceTd);

        let delTd = document.createElement('td');
        delTd.classList.add('delete');
        delTd.appendChild(this.createDeleteButton(price.id));
        row.appendChild(delTd);

        return row;
    }

    createDonationRow(price) {
        let row = document.createElement('tr');

        let nameTd = document.createElement('td');
        nameTd.innerText = `${price.name}`;
        row.appendChild(nameTd);

        let priceTd = document.createElement('td');
        priceTd.className = BEM.getBEMClassName(BLOCK_INSPECTION, ELEMENT_PRICE);
        priceTd.innerText = `- €${numeral(price.getTotal()).format('0.00')}`;
        row.appendChild(priceTd);

        let delTd = document.createElement('td');
        row.appendChild(delTd);

        return row;
    }

    updateInspection() {
        this.removeInspectionRows();

        let inspectionTickets = BEM.getBEMNode(BLOCK_INSPECTION, ELEMENT_TICKETS);
        for(let price of this.prices.rows) {
            let row = this.createRow(price);
            inspectionTickets.appendChild(row);
        }

        let inspectionFoot = BEM.getBEMNode(BLOCK_INSPECTION, "foot");
        let inspectionTotal = inspectionFoot.querySelector(".inspection__total");
        inspectionFoot.innerHTML = "";
        console.log(this.prices.discounts);
        for(let price of this.prices.discounts) {
            let row = this.createDonationRow(price);
            inspectionFoot.appendChild(row);
        }
        inspectionFoot.appendChild(inspectionTotal);

        let discounts = BEM.getBEMNodes('discount');
        let discount = 0;
        discounts.forEach((discount_price) => {
            discount += numeral(discount_price.innerText).value();
        });

        if(discount) {
            this.prices.setDiscount(numeral(discount).value());
        }

        let checkup = BEM.getBEMNode(BLOCK_CHECKUP);
        if(this.prices.calculateTotal() <= 0 && this.prices.discount <= 0) {
            checkup.style.display = 'none';
        } else {
            checkup.style.display = 'block';
            let totalPrice = BEM.getBEMNode(BLOCK_INSPECTION, ELEMENT_TOTAL);
            totalPrice.innerText = `€${numeral(this.prices.calculateTotal()).format('0.00')}`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/my_artis/js/views/exposition/prices.js